import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { AtenderSolicitudReverso, InformacionGeneralProyeccionTH, ReversarUnidadProyeccionHEDTO, UnidadesProyeccion } from "./TypesProyecionHorasExtrasAdmin";
import axios from "axios";
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";

import configData from "config.json"
import { DownloadDocument, DownloadDocumentWithAPI } from "helpers/files";
import { authenticationService } from "services/authentication.service";
import { downloadExcelReport } from "helpers/downloadExcelReport";
import { URL_REPORTE_PROYECCIONES_EXCEL, URL_REPORTE_PROYECCIONES_PDF } from "components/DirectivoUnidad/Horas Extras/Asignacion Presupuesto/FunctionsAsignacionPresupuesto";

export const URL_SOLO_CONTROLLER_PROYECCION_HE = `ProyeccionHorasExtras`
export const URL_CONTROLLER_PROYECCION_HE = `${configData.SERVER_URL}ProyeccionHorasExtras`
const URL_INFORMACION_GENERAL_PROYECCION_UNIDAD = URL_CONTROLLER_PROYECCION_HE + "/InformacionGeneral/Unidades"
const URL_REVERSAR_UNIDAD_DESDE_TH = URL_CONTROLLER_PROYECCION_HE + "/TH/ReversoProyeccionesUnidades"
const URL_DETALLE_PROYECCIONES_UNIDADES = URL_CONTROLLER_PROYECCION_HE + "/DetalleUnidades"
const URL_ENVIAR_PROYECCIONES_A_GPE= URL_CONTROLLER_PROYECCION_HE + "/TH/EnvioProyeccionesUnidadesGPE"
const URL_ATENDER_SOLICITUD_REVERSO = URL_CONTROLLER_PROYECCION_HE + "/TH/SolicitudReverso"

const URL_REPORTE_PDF_PROYECCION_UNIDADES_TH = URL_CONTROLLER_PROYECCION_HE + "/TH/ReportePDFProyeccionUnidades"

const URL_REPORTE_EXCEL_PROYECCION_UNIDADES_TH =URL_SOLO_CONTROLLER_PROYECCION_HE + "/TH/ReporteExcelProyeccionUnidades"




export async function ObtenerInformacionGeneralProyeccionesUnidades(){
    var respuesta:ResponseRequestGeneric<InformacionGeneralProyeccionTH>= {
        status:-1
    };

    try {

        const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PROYECCION_UNIDAD, {
            headers: authHeader()
        })

        var data:InformacionGeneralProyeccionTH|undefined = responseAxios.data;

        

        respuesta = {
            status : responseAxios.status,
            dataResponse : data
        }
        



        
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionGeneralProyeccionTH>(error)
    }

    return respuesta
}

export async function ObtenerInformacionTablaProyeccionesUnidades(idProyeccionHE:number){
    var respuesta:ResponseRequestGeneric<UnidadesProyeccion[]>= {
        status:-1
    };

    try {

        const URL_COMPLETA = `${URL_DETALLE_PROYECCIONES_UNIDADES}/${idProyeccionHE}`

        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data:UnidadesProyeccion[] = responseAxios.data;

        

        respuesta = {
            status : responseAxios.status,
            dataResponse : data
        }
        



        
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<UnidadesProyeccion[]>(error)
    }

    return respuesta
}

export async function ReversarUnidadDesdeTH(unidad: ReversarUnidadProyeccionHEDTO){
    var respuesta:ResponseRequestGeneric<void>= {
        status:-1
    };

    try {

        const responseAxios = await axios.put(URL_REVERSAR_UNIDAD_DESDE_TH,unidad,
         {
            headers: authHeader()
        })


        respuesta = {
            status : responseAxios.status,
        }
        

        
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta
}

export async function EnviarProyeccionesUnidadesAGPE(idProyeccionHE:number){
    var respuesta:ResponseRequestGeneric<void[]>= {
        status:-1
    };

    try {

        const URL_COMPLETA = `${URL_ENVIAR_PROYECCIONES_A_GPE}/${idProyeccionHE}`

        const responseAxios = await axios.put(URL_COMPLETA,{} ,{
            headers: authHeader()
        })


        respuesta = {
            status : responseAxios.status,
        }
        



        
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void[]>(error)
    }

    return respuesta
}


export async function ObtenerReporteProyeccionesUnidadesTH(idProyeccionHE:number, tipo:"TH"|"GPE"){
    
    var URLCOMPLETA = `${URL_REPORTE_PDF_PROYECCION_UNIDADES_TH}/${idProyeccionHE}`
    if(tipo === "GPE"){
        URLCOMPLETA = `${URL_REPORTE_PROYECCIONES_PDF}/${idProyeccionHE}`
        
    }

    await DownloadDocumentWithAPI(URLCOMPLETA,authenticationService.currentUserValue.token,"REPORTE PROYECCIÓN UNIDADES.pdf")
}

export async function ObtenerReporteExcelProyeccionesUnidadesTH(idProyeccionHE:number, tipo:"TH"|"GPE"){
    
    var URLCOMPLETA = `${URL_REPORTE_EXCEL_PROYECCION_UNIDADES_TH}/${idProyeccionHE}`
    if(tipo === "GPE"){
        URLCOMPLETA = `${URL_REPORTE_PROYECCIONES_EXCEL}/${idProyeccionHE}`
        
    }


    await downloadExcelReport(URLCOMPLETA,"REPORTE PROYECCIÓN UNIDADES.xlsx")
}

export async function PutAtenderSolicituReverso(info:AtenderSolicitudReverso){
    var respuesta:ResponseRequestGeneric<void>= {
        status:-1
    };

    try {

        const responseAxios = await axios.put(URL_ATENDER_SOLICITUD_REVERSO,info,
         {
            headers: authHeader()
        })


        respuesta = {
            status : responseAxios.status,
        }
        

        
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta
}
